import { useEffect, useState } from 'react';
import { fetchJsonCached } from '../lib/settingsCache';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const shopCategorySlug = (name) => (name || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/**
 * Gift shop categories, straight from the product catalogue in Admin -> Products.
 *
 * Used by the GIFT SHOP menu dropdown and the category pages, so adding a category in the
 * admin makes it appear in the menu with no code change. Disabled categories are hidden.
 */
export const useShopCategories = () => {
  const [state, setState] = useState({ categories: [], loading: true });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const data = await fetchJsonCached(`${API_URL}/api/store/categories`);
        if (cancelled) return;
        const categories = (Array.isArray(data) ? data : [])
          .filter((c) => c && c.name && c.is_enabled !== false && !c.parent_id)
          .map((c) => ({ ...c, slug: shopCategorySlug(c.name) }));
        setState({ categories, loading: false });
      } catch (error) {
        if (!cancelled) setState({ categories: [], loading: false });
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  return state;
};

export default useShopCategories;
